import { userInfoSync } from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
export function hasRedesignGate() {
  try {
    var _authInfo$gates;
    const authInfo = userInfoSync();
    return ((_authInfo$gates = authInfo === null || authInfo === void 0 ? void 0 : authInfo.gates) !== null && _authInfo$gates !== void 0 ? _authInfo$gates : []).includes(gate('CJComponents:ComponentsRedesign:OnboardingTours'));
  } catch (_unused) {
    return false;
  }
}